import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row, UiQuestionnaireLayout, UiText} from '~/components/elements';
import SpecialText from '~/components/shared/SpecialText';
import {
  SYMPTOM_BLOCK_NAMES,
  WEIGHT_LOSS_KEYS,
  WEIGHT_LOSS_ONE_QUESTIONNAIRES,
  WL_PROGRAMS,
} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const Questionnaire7AScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.BMI_ALLERGIC);

  const questionnaireFollowingApply = WEIGHT_LOSS_ONE_QUESTIONNAIRES?.find(
    i => i.key === WEIGHT_LOSS_KEYS.FOLLOWING_APPLY,
  );

  const selectedProgram = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.PROGRAM_SELECTION]?.data?.selectedProgramLocal,
  );

  const selectedProgramData = Object.values(WL_PROGRAMS).find(i => i.localValue === selectedProgram);
  const selectedProgramName = selectedProgramData?.label || 'The product';
  const selectedProgramTitle = SYMPTOM_BLOCK_NAMES[selectedProgramData?.localValue || 'This'];

  const currentFollowingApplyAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.FOLLOWING_APPLY]?.data,
  );

  const selectedOptions = questionnaireFollowingApply?.options?.filter(el =>
    currentFollowingApplyAnswer?.selectedOptions?.includes(el.value),
  );

  const collectedData = mdq.collectedData;

  useEffect(() => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.BMI_ALLERGIC,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    if (medicalUUID) {
      dispatch(
        submitOrLogMdq({
          data: {
            uid: medicalUUID,
            methodKey: methodKey.toLowerCase(),
            status: 'draft',
            data: {
              ...collectedData,
              [WEIGHT_LOSS_KEYS.BMI_ALLERGIC]: answerData,
            },
          },
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions} pageTitle={questionnaire?.title}>
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="2xl" fontWeight="bold" mb={6}>
          {selectedProgramName?.replace('Elevate', `Elevate’s`)} {questionnaire?.questions?.default}
        </UiText>
        <UiText maxW={80} fontSize="sm" mb={8}>
          {selectedProgramTitle + ' ' + questionnaire?.questions?.sub}
        </UiText>
        <Col mb={3}>
          {selectedOptions?.map(option => (
            <UiText key={option.value} fontSize="xs" fontWeight="bold" mb={3.5}>
              {option.label}
            </UiText>
          ))}
        </Col>
        <Col>
          {questionnaire?.descriptions?.default?.map(desc => (
            <UiText key={desc} fontSize="sm" mb={3}>
              {desc}
            </UiText>
          ))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire7AScreen;
